export enum LocaleType {
  en_us = 'en_us',
  zh_tw = 'zh_tw',
  zh_cn = 'zh_cn',
}